import React from "react"
import styled from 'styled-components';
import {Icon, Button, Tag} from '@blueprintjs/core';
import { useNavigate } from 'react-router';

import defaultLogo from 'url:../../../../styles/logos/dashboard-logo.png';
import {variables} from '/src/styles/variables';
import {Scrollbars} from 'react-custom-scrollbars-2';
import {version} from '/package.json';
import {AVL_ENVIRONMENT} from "/src/config/vars";

import OrganisationSwitcher from '../organisation-switcher';
import MenuItem from './menu-item';

const Wrapper = styled.section`
    width: ${variables.desktopNavbarWidth};
    background: #19212F;
    flex: 0;
    order: -1;
    height: 100vh;
    overflow-y: auto;
    filter: ${(props) => (props.$blur ? `blur(${props.$blur})` : '')};
`;
const FlexScrollbars = styled(Scrollbars)`
    & > div {
        display: flex;
        flex-direction: column;
    }
`;
const Menu = styled.div`
    margin-top: 1em;
`;
const MenuDivider = styled.div`
    margin: 1em 1.5em;
    border-bottom: 1px solid #2c3545;
`;
const UserSection = styled.section`
    margin: 0.5em;
    margin-top: 2.5em;
    padding: 1.5em 1em;
    color: rgba(255, 255, 255, 0.8);
    border-top: 1px solid #2c3545;
    display: flex;
    background: #19212F;
    position: relative;
`;
const VersionSection = styled.section`
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    opacity: 0.5;
    width: 100%;
    margin: auto 0 0.5rem;
`;
const UserTextSection = styled.div`
    flex: 1;
    margin-left: 1em;
`;
const UserName = styled.p`
    font-size: 0.9em;
    margin-bottom: 0.3em;
`;
const OrgName = styled.p`
    font-size: 0.85em;
`;
const LogoutButton = styled(Button)`
    color: rgba(255, 255, 255, 0.8) !important;
    background: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.8);

    & .bp6-button-text {
        color: rgba(255, 255, 255, 0.8) !important;
    }
`;
const Logo = styled.img`
    width: 100%;
`;
const PoweredLogo = styled.div`
    display: block;
    margin: 1rem auto 2rem;
    width: 124px;
    aspect-ratio: 123 / 22;
`;

const DesktopSidebar = ({
                            user = {},
                            availableOrganisations = [],
                            blur,
                            logout,
                            menuItems,
                            location,
                        }) => {
    const navigate = useNavigate();

    return (
        <Wrapper $blur={blur}>
            <FlexScrollbars
                renderThumbVertical={({style, props}) => {
                    const customStyle = {
                        backgroundColor: 'rgb(255, 255, 255, 0.2)',
                        borderRadius: '3px',
                    };
                    return <div {...props} style={{...style, ...customStyle}}/>;
                }}
            >
                <Logo src={defaultLogo} alt="Aura Vision Labs logo"/>
                {AVL_ENVIRONMENT !== "prod" &&
                    <Tag
                        large
                        intent={AVL_ENVIRONMENT === "uat" ? "warning" : "danger"}
                        style={{textAlign: "center"}}>
                        {AVL_ENVIRONMENT === "uat" ? "UAT" : "RISK UNKNOWN ENVIRONMENT"}
                    </Tag>
                }
                <Menu>
                    {menuItems.map((item, index) => {
                        if (item.type === 'divider')
                            return <MenuDivider key={`divider-${index}`}/>;
                        return (
                            <MenuItem key={item.label} item={item} location={location}/>
                        );
                    })}
                </Menu>
                <UserSection>
                    <Icon icon="user"/>
                    <UserTextSection>
                        <UserName>{user.email}</UserName>
                        {user.organisation?.name && <OrgName>{user.organisation.name}</OrgName>}
                        <LogoutButton minimal onClick={() => navigate(logout)}>Logout</LogoutButton>
                        {availableOrganisations.length > 1 &&
                            <OrganisationSwitcher user={user} availableOrganisations={availableOrganisations}/>}
                    </UserTextSection>
                </UserSection>
                <VersionSection>{AVL_ENVIRONMENT === "uat" ? "uat-" : ""}v{version}</VersionSection>
            </FlexScrollbars>
        </Wrapper>
    );
};

export default DesktopSidebar;
